module.exports = __webpack_public_path__ + "img/logo-fondIndePresse.b224663a.svg";